export default "__VITE_ASSET__CDWdyafa__"